import { CustomContact } from 'api/services/BrandPortal/CustomContacts';

export const contactIsEqual = (a: CustomContact, b: CustomContact) =>
  a.email_address === b.email_address &&
  a.manufacturer === b.manufacturer &&
  a.distributor === b.distributor &&
  a.factory === b.factory;

export const getContactKey = (contact: CustomContact) =>
  contact.email_address +
  contact.distributor +
  contact.manufacturer +
  contact.factory;
